import table from '@/components/common/table.vue';
import panel from '@/components/common/panel.vue';
import Vue from 'vue'; // 修正小写vue为Vue（规范+避免潜在问题）

// 生成构造函数（重命名避免混淆）
const TableComponent = Vue.extend(table);
const PanelComponent = Vue.extend(panel);

const extendedInstances = [];

// 通用创建实例函数（核心优化）
function createInstanceTemp(Component, content) {
  return new Promise((resolve) => {
    // 1. 初始化实例时直接传入content，保证响应式
    const instance = new Component({
      el: document.createElement('div'),
      data() {
        return {
          content: { ...content } // 深拷贝用户传入的配置，避免引用污染
        };
      }
    });

    // 保存实例到全局数组
    extendedInstances.push(instance);
    document.body.appendChild(instance.$el);

    // 2. 绑定confirm/cancel方法（保证show状态修改后异步销毁）
    instance.confirm = function (data) {
      resolve(data);
      instance.content.show = false;
      setTimeout(() => removeDom(instance), 100); // 异步销毁，给组件关闭动画时间
    };
    instance.cancel = () => {
      resolve(false);
      instance.content.show = false;
      setTimeout(() => removeDom(instance), 100);
    };
  });
}

// 修复TableTemp：传对组件和content
function TableTemp(content) {
  return createInstanceTemp(TableComponent, content); // Table组件 + 用户传入的content
}

// PanelTemp保持逻辑（传Panel组件 + 用户content）
function PanelTemp(content) {
  return createInstanceTemp(PanelComponent, content);
}

// 销毁所有实例（优化：避免重复销毁）
function destroyAllExtendedComponents() {
  extendedInstances.forEach(instance => {
    if (instance && !instance._isDestroyed) {
      instance.$destroy();
      if (instance.$el && instance.$el.parentNode) {
        instance.$el.parentNode.removeChild(instance.$el);
      }
    }
  });
  extendedInstances.length = 0;
}

// 修复removeDom的DOM判断逻辑
function removeDom(instance) {
  // 1. 先标记隐藏
  if (instance.content) {
    instance.content.show = false;
  }
  // 2. 正确判断$el是否在body中
  if (document.body.contains(instance.$el)) {
    document.body.removeChild(instance.$el);
  }
  // 3. 销毁实例并从数组移除
  if (!instance._isDestroyed) {
    instance.$destroy();
  }
  const index = extendedInstances.indexOf(instance);
  if (index > -1) {
    extendedInstances.splice(index, 1);
  }
}

// 挂载全局方法（修正小写vue）
function createExtend(Vue) { // Vue.use会传入Vue构造函数，这里接收更规范
  Vue.prototype.$panelTemp = PanelTemp;
  Vue.prototype.$tableTemp = TableTemp;
  Vue.prototype.$destroyAllExtendedComponents = destroyAllExtendedComponents;
}

export default createExtend;


// WEBPACK FOOTER //
// ./src/utils/extendsTemp.js